export default __webpack_public_path__ + "static/media/792.71a9cec1.png";